import {
  Card,
  CardContent,
  Label,
  styled,
  ToggleButton,
} from '@nextiva/next-ui-components';

export const CustomToggleButton = styled(ToggleButton)`
  color: #0b1029;
  border: none;
  margin: 4px 2px 4px 4px;
  padding: 4px 8px;
  border-radius: 2px;
  &.Mui-selected {
    color: ${({ theme }) => theme.palette.common.white};
    background-color: ${({ theme }) => theme.palette.blue[800]};
    &:hover {
      background-color: ${({ theme }) => theme.palette.blue[800]};
    }
  }
`;

export const CardStyled = styled(Card)<{ checked: boolean }>`
  min-width: 280px;
  min-height: 200px;
  gap: 5px;
  background-color: ${({ theme }) => theme.palette.common.white};
  border: ${({ checked, theme }) =>
    checked ? `1px solid ${theme.palette.blue[800]}` : `1px solid transparent`};
  &:hover {
    background-color: ${({ theme }) => theme.palette.blue.A50};
  }
  &[data-active]: {
    background-color: ${({ theme }) => theme.palette.deepOrange[300]};
  }
`;

export const CardContentStyled = styled(CardContent)`
  position: relative;
  min-height: 176px;
  padding: 16px;
  &:last-child {
    padding-bottom: 16px;
  }
`;

export const LabelStyled = styled(Label)`
  padding: 2px 4px 3px 4px;
`;

export const LabelDiscount = styled(Label)<{ checked: boolean }>`
  background-color: ${({ checked, theme }) =>
    checked ? theme.palette.blue[800] : theme.palette.blue[50]};
  color: ${({ checked, theme }) =>
    checked ? theme.palette.common.white : '#0B1029'};
  border: ${({ checked, theme }) =>
    checked
      ? `1px solid ${theme.palette.common.white}`
      : `1px solid ${theme.palette.blue[50]}`};
  padding: 2px 4px;
  margin-left: 4px;
`;
